;(function () {
    "use strict";

    var selector = ".notify_dismissable:not(.notify_dismissable_dismiss-button-only), " +
                   ".notify_dismissable_dismiss-button-only .notify__dismiss.notify__dismiss_button";

    $(document).on("click.notify", selector, function(event) {
        event.preventDefault();

        var $elm    = $(this).hasClass('notify_dismissable') ? $(this) : $(this).closest('.notify_dismissable'),
            postUrl = $elm.data('notifyPostUrl');

        var dismiss = function() {

            if (Modernizr.csstransitions) {
                $elm
                .addClass("notify_dismissed")
                .css('margin-bottom', '-' + $elm.outerHeight(true) + 'px');

                $elm.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend', function() {
                    $elm.css('display', 'none');

                    if ( $elm.parent().is('.notify-holder') ) {
                        $elm.parent().css('display', 'none');
                    }
                });
            }
            else {
                $elm.css('display', 'none');

                if ( $elm.parent().is('.notify-holder') ) {
                    $elm.parent().css('display', 'none');
                }
            }

            if ( $elm.parent().is('.notify-holder') ) {
                $elm.parent().addClass('notify-holder_hidden');
            }

            if ( Boolean($elm.attr('popup_id')) ) {
                $.post('/up/' + $elm.attr('popup_id') + '/');
            }
        };

        if (!$elm.hasClass('notify_pending')) {

            if (Boolean(postUrl)) {

                $elm.addClass('notify_pending');

                $.post(postUrl)
                .fail(function(response) {
                    $elm
                    .removeClass('notify_dismissable_dismiss-button-only')
                    .text(Boolean(response && false) ? responseText : 'Что-то пошло не так, пожалуйста попробуйте позднее' )
                    .removeData('notifyPostUrl')
                    .removeAttr('data-notify-post-url')
                })
                .success(function() {
                    dismiss();
                })
                .always(function() {
                    $elm.removeClass('notify_pending');
                });
            }
            else {
                dismiss();
            }
        }
    });
})();